import { render, staticRenderFns } from "./AdminRecruiterChooser.vue?vue&type=template&id=5df41862&scoped=true"
import script from "./AdminRecruiterChooser.vue?vue&type=script&lang=js"
export * from "./AdminRecruiterChooser.vue?vue&type=script&lang=js"
import style0 from "./AdminRecruiterChooser.vue?vue&type=style&index=0&id=5df41862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df41862",
  null
  
)

export default component.exports